import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AnonymousNewRequestPage } from '@core/models/leave-admin/anonymous-request/anonymous-new-request.model';
import { HeaderService } from '@core/services';
import { AnonymousRequestsStoreService } from '@core/services/anonymous-requests-store.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-anonymous-new-request',
    templateUrl: './anonymous-new-request.component.html',
    styleUrls: ['./anonymous-new-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnonymousNewRequestComponent implements OnInit, OnDestroy {
  static readonly componentName = 'AnonymousNewRequestComponent';
  
  sysText: any;
  anonymousNewRequestPage$: Observable<AnonymousNewRequestPage>;

  constructor(
    private store: AnonymousRequestsStoreService,
    private headerService: HeaderService,
  ) { }

  ngOnInit(): void {
    this.sysText = this.store.sysText;
    this.headerService.setPageTitle(this.sysText.anonymousNewRequest.anonymousNewRequest_title);
    this.anonymousNewRequestPage$ = this.store.anonymousRequestPage$;
  }

  ngOnDestroy(): void {
    this.store.unloadStore();
  }
}
